import { useState, useEffect, useMemo } from 'react';
import { Flipper, Flipped } from 'react-flip-toolkit';

import TableMobileSort from './TableMobileSort';
import TableMobileItem from './TableMobileItem';
import sort from 'js/utils/sort-table';

import { ITableMobile, ITableMobileItem } from 'source/NFR.types';

const extractValue = (x: ITableMobileItem, sortOption: string): string | undefined => {
  const item = x.list.find(({ label }) => label === sortOption);
  return item && item.value;
};

// pick a stable id per row
const getItemId = (item: ITableMobileItem): string =>
  item?.list?.[1]?.value || item?.list?.[0]?.value || JSON.stringify(item);

const TableMobile: React.FC<ITableMobile> = ({ items, sortMenu }) => {
  const [sortOption, setSortOption] = useState(items[0]?.list[0]?.label || '');
  const [itemsState, setItemsState] = useState(() => {
    const label = items[0]?.list[0]?.label || '';
    if (!label || !items) return items || [];
    return [...items].sort((a, b) => sort(extractValue(a, label) ?? '', extractValue(b, label) ?? ''));
  });

  useEffect(() => {
    if (!sortOption) return;
    setItemsState(prev =>
      [...prev].sort((a, b) => sort(extractValue(a, sortOption) ?? '', extractValue(b, sortOption) ?? ''))
    );
  }, [sortOption]);

  // changes whenever order or sortOption changes
  const flipKey = useMemo(() => {
    const ids = itemsState.map(getItemId).join('|');
    return `${sortOption}:${ids}`;
  }, [itemsState, sortOption]);

  if (!items || !items.length || !items[0]) return null;

  const sortOptions = items[0].list?.map(({ label }) => label);

  return (
    <div className="table-mobile">
      <TableMobileSort options={sortOptions} selectedOption={sortOption} setSortOption={setSortOption} {...sortMenu} />
      <Flipper flipKey={flipKey} spring="noWobble" staggerConfig={{ default: { speed: 1 } }}>
        <div>
          {itemsState?.map(item => {
            const id = getItemId(item);
            return (
              <Flipped key={id} flipId={id}>
                <div>
                  <TableMobileItem {...item} />
                </div>
              </Flipped>
            );
          })}
        </div>
      </Flipper>
    </div>
  );
};

TableMobile.displayName = 'TableMobile';

export default TableMobile;
